<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <template v-if="methodOfCollection">
      <method-of-collection-form
        :isLoading="isLoading"
        :methodOfCollection="methodOfCollection"
        :onSubmit="onSubmit">
      </method-of-collection-form>
    </template>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import MethodOfCollectionForm from './MethodOfCollectionForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { methodOfCollectionService } = biobankRegistry;

export default {
  name: 'MethodOfCollectionCreate',
  components: {
    MethodOfCollectionForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Update Method of Collection',
      enableBackButton: true,
    },
    methodOfCollection: null,
  }),
  async created() {
    const { id } = this.$route.params;
    const methodOfCollection = await methodOfCollectionService.getOne({ id });
    this.methodOfCollection = methodOfCollection;
  },
  methods: {
    async onSubmit(dataChange) {
      const data = Object.assign(this.methodOfCollection || {}, dataChange);

      this.isLoading = true;
      try {
        await methodOfCollectionService.update({ methodOfCollection: data });

        this.$snackbar.showOk({ text: 'Successfully updated collection method!' });

        this.$router.push({ name: 'method-of-collection.list' });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
